import { createSlice } from "@reduxjs/toolkit"

type doctorCompensationStateType = {
  contractColumns: any[]
  contractData: any[]
  doctorList: any[]
  providerList: any[]
  selectedProvider: any[]
  currentContract: any

  //static
  doctorCompensationTabs: any
  selectedDoctorCompensationTab: any
  statusList: any[]
  selectedStatus: any[]
  summaryColumns: any[]
  summaryData: any[]
  payrollColumns: any[]
  payrollData: any[]
  labExpensesColumns: any[]
  labExpensesData: any[]
  journalEntriesColumns: any[]
  journalEntriesData: any[]
  yearList: any[]
  selectedYear: any[]
  monthList: any[]
  selectedMonth: any[]
  summaryMemoList: any[]
  selectedSummaryMemo: any[]
  qboMemoList: any[]
  selectedMemo: any[]
}

const initialState: doctorCompensationStateType = {
  contractColumns: [],
  doctorList: [],
  providerList: [],
  selectedProvider: [],
  statusList: [
    { label: "All", name: "all" },
    { label: "Active", name: "active" },
    { label: "Inactive", name: "inactive" },
  ],
  selectedStatus: [],
  summaryColumns: [],
  summaryData: [],
  payrollColumns: [],
  payrollData: [],
  labExpensesColumns: [],
  labExpensesData: [],
  journalEntriesColumns: [],
  journalEntriesData: [],
  yearList: [],
  selectedYear: [],
  monthList: [
    { label: "January", name: "1" },
    { label: "February", name: "2" },
    { label: "March", name: "3" },
    { label: "April", name: "4" },
    { label: "May", name: "5" },
    { label: "June", name: "6" },
    { label: "July", name: "7" },
    { label: "August", name: "8" },
    { label: "September", name: "9" },
    { label: "October", name: "10" },
    { label: "November", name: "11" },
    { label: "December", name: "12" },
  ],
  selectedMonth: [],
  summaryMemoList: [],
  selectedSummaryMemo: [],
  qboMemoList: [],
  selectedMemo: [],
  contractData: [],
  currentContract: {},

  //static

  doctorCompensationTabs: [],
  selectedDoctorCompensationTab: {
    index: 0,
    id: "compensation",
    name: "Compensation",
  },
}

const doctorCompensationSlice = createSlice({
  name: "doctorCompensation",
  initialState,
  reducers: {
    //static
    setDoctorCompensationTabs: (state, action) => {
      state.doctorCompensationTabs = action.payload
    },
    setSelectedDoctorCompensationTab: (state, action) => {
      state.selectedDoctorCompensationTab = action.payload
    },
    setContractColumns: (state, action) => {
      state.contractColumns = action.payload
    },
    setContractData: (state, action) => {
      state.contractData = action.payload
    },
    setDoctorList: (state, action) => {
      state.doctorList = action.payload
    },
    setProviderList: (state, action) => {
      state.providerList = action.payload
    },
    setCurrentContract: (state, action) => {
      state.currentContract = action.payload
    },
    setSelectedProvider: (state, action) => {
      state.selectedProvider = action.payload
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload
    },
    setSummaryColumns: (state, action) => {
      state.summaryColumns = action.payload
    },
    setSummaryData: (state, action) => {
      state.summaryData = action.payload
    },
    setPayrollColumns: (state, action) => {
      state.payrollColumns = action.payload
    },
    setPayrollData: (state, action) => {
      state.payrollData = action.payload
    },
    setLabExpensesColumns: (state, action) => {
      state.labExpensesColumns = action.payload
    },
    setLabExpensesData: (state, action) => {
      state.labExpensesData = action.payload
    },
    setJournalEntriesColumns: (state, action) => {
      state.journalEntriesColumns = action.payload
    },
    setJournalEntriesData: (state, action) => {
      state.journalEntriesData = action.payload
    },
    setYearList: (state, action) => {
      state.yearList = action.payload
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload
    },
    setMonthList: (state, action) => {
      state.monthList = action.payload
    },
    setSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload
    },
    setSummaryMemoList: (state, action) => {
      state.summaryMemoList = action.payload
    },
    setSelectedSummaryMemo: (state, action) => {
      state.selectedSummaryMemo = action.payload
    },
    setQboMemoList: (state, action) => {
      state.qboMemoList = action.payload
    },
    setSelectedMemo: (state, action) => {
      state.selectedMemo = action.payload
    },
  },
})

export default doctorCompensationSlice.reducer

export const {
  setDoctorCompensationTabs,
  setSelectedDoctorCompensationTab,
  setContractColumns,
  setContractData,
  setDoctorList,
  setProviderList,
  setCurrentContract,
  setSelectedProvider,
  setSelectedStatus,
  setSummaryColumns,
  setSummaryData,
  setPayrollColumns,
  setPayrollData,
  setLabExpensesColumns,
  setLabExpensesData,
  setJournalEntriesColumns,
  setJournalEntriesData,
  setYearList,
  setSelectedYear,
  setMonthList,
  setSelectedMonth,
  setSummaryMemoList,
  setSelectedSummaryMemo,
  setQboMemoList,
  setSelectedMemo,
} = doctorCompensationSlice.actions
